<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/AcI6CR/images/cover.jpg?1684514754430" alt="This image is the cover for the book Forgotten Heroes & Villains of Sand Creek"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Forgotten Heroes & Villains of Sand Creek
      </h1>
      <p class="bookDescription body article font2">
        <p>On November 29, 1864, Colonel John Chivington led a bloody and terrible raid on an encampment of Arapahos and Cheyennes who had come to the area believing they were on a path to peace. Before it was over, between 130 and 180 Native Americans had been massacred. This attack, known as the Sand Creek Massacre, is one of the most well-known and notorious events in Colorado�s history. In Forgotten Heroes and Villains of Sand Creek, author Carol Turner turns an eye to the central characters, their histories and how they came to be part of this bloody episode. This fascinating look at such a pivotal event, its instigators and its martyrs includes the stories of John Chivington, an ambitious preacher with a streak of cruelty; Captain Silas Soule, a man who is still honored today by the Cheyenne and Arapaho tribes for his efforts in saving their ancestors; Ned Wynkoop, one of Soule�s compatriots who had a change of heart regarding the tribes; Chief One Eye, a persuasive and charismatic medicine man; and many, many more.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carol Turner
      </h2>
      
      <p class="authorDescription body article">Carol Turner has a BA in English from Sonoma State University and an MFA in creative writing and literature from Bennington College. She is the author of Economics for the Impatient, and her short fiction has appeared in numerous literary magazines. She lives in Colorado, writes a history column for the Broomfield Enterprise and maintains a Colorado history blog.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5068c975